import React from "react";
import { Button, Modal } from "semantic-ui-react";
import { Constants } from "../../config/appConstants";
import { Worker, Viewer } from "@react-pdf-viewer/core";

const AttestationModal = (props) => {
  let attestationFormBase64 = props?.attestationPDF?.attachmentContent;
  let attestationBase64 = attestationFormBase64;
  if(attestationFormBase64) {
    attestationFormBase64 = Constants.PDFDATA_BASE64 + attestationFormBase64;
  }

  const downloadAttestation = () => {
    if (!attestationFormBase64) return;
    const downloadLink = document.createElement("a");
    downloadLink.href = attestationFormBase64;
    downloadLink.download = props.attestationPDF.attachmentName;
    downloadLink.click();
  };

  const printAttestation = () => {
    if (!attestationFormBase64) return;
    function base64ToBlob(base64, type) {
      const binary = atob(base64.replace(/\s/g, ""));
      const len = binary.length;
      const buffer = new ArrayBuffer(len);
      const view = new Uint8Array(buffer);
      for (let i = 0; i < len; i++) {
        view[i] = binary.charCodeAt(i);
      }
      return new Blob([view], { type: type });
    }

    const blob = base64ToBlob(attestationBase64, "application/pdf");
    const url = URL.createObjectURL(blob);

    const printWindow = window.open("", "PDF", "left=0,top=0,width=850,height=700,toolbar=0,scrollbars=2,status=0");

    if (printWindow) {
      printWindow.document.write(`
      <html>
      <head>
          <title>Print PDF</title>   
      </head>
      <body style="margin: 0;">
          <iframe
              id="pdfFrame"
              src="${url}"
              type="application/pdf"
              style="border: none; width: 100%; height: 100vh;"
          ></iframe>
          <script>
              const iframe = document.getElementById('pdfFrame');
              iframe.onload = function() {
                  setTimeout(() => {
                      iframe.contentWindow.print();
                  }, 1000);
              };
          </script>
      </body>
      </html>
    `);
      printWindow.document.close();
    }
  };

  return (
    <Modal
      closeIcon
      open={props.isShowAttestationModal}
      closeOnDimmerClick={false}
      size="medium"
      onClose={() => props.onOpenOrCloseAttestationModal()}
    >
      <Modal.Content scrolling style={{ minHeight: "auto" }}>
        {attestationFormBase64 && (
          <div style={{ width: "100%", height: "100%" }}>
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.2.228/build/pdf.worker.min.js">
              <Viewer
                fileUrl={attestationFormBase64}
                defaultScale={1.2}
              />
            </Worker>
          </div>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button primary onClick={() => downloadAttestation()}>Download</Button>
        <Button primary onClick={() => printAttestation()}>Print</Button>
        <Button secondary onClick={() => props.onOpenOrCloseAttestationModal()}>Back</Button>
      </Modal.Actions>
    </Modal>
  );
};

export default AttestationModal;
